// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/font/NAPASANS-Roman.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/font/NAPASANS-Roman.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/font/NAPASANS-Roman.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/font/NAPASANS-Roman.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --custom-color: #001489;
}

@font-face {
  font-family: "myfont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-display: swap;
}

* {
  font-family: myfont !important;
}

body {
  margin: 0;
  overflow-x: hidden;
  font-family: myfont;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -moz-transform: scale(0.8, 0.8); /* Moz-browsers */
  zoom: 0.8; /* Other non-webkit browsers */
  zoom: 80%; /* Webkit browsers */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C;;;8DAG4D;EAC5D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B,EAAE,iBAAiB;EAClD,SAAS,EAAE,8BAA8B;EACzC,SAAS,EAAE,oBAAoB;AACjC","sourcesContent":[":root {\n  --custom-color: #001489;\n}\n\n@font-face {\n  font-family: \"myfont\";\n  src: url(\"./assets/font/NAPASANS-Roman.eot\");\n  src: url(\"./assets/font/NAPASANS-Roman.woff2\") format(\"woff2\"),\n    url(\"./assets/font/NAPASANS-Roman.woff\") format(\"woff\"),\n    url(\"./assets/font/NAPASANS-Roman.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"./assets/font/NAPASANS-Roman.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-display: swap;\n}\n\n* {\n  font-family: myfont !important;\n}\n\nbody {\n  margin: 0;\n  overflow-x: hidden;\n  font-family: myfont;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -moz-transform: scale(0.8, 0.8); /* Moz-browsers */\n  zoom: 0.8; /* Other non-webkit browsers */\n  zoom: 80%; /* Webkit browsers */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
